import { useState } from "react";

export function CopyField({
  value,
  label,
  multiline,
}: {
  value: string;
  label?: string;
  multiline?: boolean;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // no-op
    }
  }

  return (
    <div>
      {label && <label className="label">{label}</label>}
      <div className="flex items-stretch gap-2">
        {multiline ? (
          <textarea
            readOnly
            value={value}
            rows={3}
            className="input font-mono text-xs"
            onClick={(e) => (e.currentTarget as HTMLTextAreaElement).select()}
          />
        ) : (
          <input
            readOnly
            value={value}
            className="input font-mono text-xs"
            onClick={(e) => (e.currentTarget as HTMLInputElement).select()}
          />
        )}
        <button onClick={copy} className="btn-secondary shrink-0" type="button">
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
